<template>
  <components-table :view="view"/>
</template>

<script>
import { mapState } from 'vuex'
import componentsTable from './table'

export default {
  components: {
    componentsTable
  },
  computed: {
    ...mapState('tenants', {
      view: '_defaultView'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/admin/components/all.vue